import { createContext, useContext } from "react";
import { AdminContext } from "use-smart-locks-shared";

export const AdminContextState = createContext<AdminContext | null>(null);

export const useAdminContext = (): AdminContext => {
  const context = useContext(AdminContextState);

  if (!context) {
    throw new Error("useAdminContext must be used inside AdminRoot");
  }

  return context;
};
